module.exports = __webpack_public_path__ + "img/HA2511-188.c8f624f7.jpg";